const PdfIcon = ({stroke = 'black'}) => (
    <svg xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 48 48" 
        width="48" height="48">
    <path fill="#e53935" d="M6 4h24l12 12v28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2z"/>
    <path fill="#b71c1c" d="M30 4v12h12"/>
    <text x="12" y="34" 
            fontFamily="Arial, sans-serif"
            fontSize={14} 
            fontWeight={"bold"}
            fill="white">PDF</text>
    </svg>
);

export default PdfIcon;
